import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";
import { StyleableSvgImage } from "@ubnt/store.core/lib/components/StyleableSvgImage";
import * as S from "./ButtonGroup.styles";
import type { ButtonGroupProps } from "./ButtonGroup.types";

export const ButtonGroup = ({
  items,
  activeButton,
  onClick,
}: ButtonGroupProps) => {
  const { formatMessage } = useModelCompareTranslation();

  const spotlightItems = items.filter((item) => item?.isSpotlightGroup);
  const normalItems = items.filter((item) => !item?.isSpotlightGroup);

  // Fine for now. TODO would to make spotlight items compatible for multiple spotlights?
  // ^ Would need a reason to do this -- Design etc

  return (
    <S.Container>
      {spotlightItems.length > 0 && (
        <S.Buttons $isSpotlight={true}>
          {spotlightItems.map((item) =>
            item ? (
              <S.Button
                id={`${item.id}-tab`}
                key={item.id}
                $isActive={item.id === activeButton}
                onClick={() => onClick(item.id)}
              >
                <StyleableSvgImage
                  src={item.icon.src}
                  width={item.icon.width}
                  height={item.icon.height}
                />
                <S.ButtonCopy>{formatMessage(item.title)}</S.ButtonCopy>
              </S.Button>
            ) : null,
          )}
        </S.Buttons>
      )}
      <S.Buttons>
        {normalItems.map((item) =>
          item ? (
            <S.Button
              id={`${item.id}-tab`}
              key={item.id}
              $isActive={item.id === activeButton}
              onClick={() => onClick(item.id)}
            >
              <StyleableSvgImage
                src={item.icon.src}
                width={item.icon.width}
                height={item.icon.height}
              />
              <S.ButtonCopy>{formatMessage(item.title)}</S.ButtonCopy>
            </S.Button>
          ) : null,
        )}
      </S.Buttons>
    </S.Container>
  );
};
